import isNotWhitespaceString from './isNotWhitespaceString';

export default function sanitizePotentialString(val: any): string | null {
  return isNotWhitespaceString(val) ? val.trim() : null;
}
